$(document).ready(function(){

  var comfyText = (function(){
    var tag = document.querySelectorAll('textarea')
    for (var i=0; i<tag.length; i++){
      tag[i].addEventListener('paste',autoExpand)
      tag[i].addEventListener('input',autoExpand)
      tag[i].addEventListener('keyup',autoExpand)
    }
    function autoExpand(e,el){
      var el = el || e.target
      el.style.height = 'inherit'
      el.style.height = el.scrollHeight+'px'
    }
    window.addEventListener('load',expandAll)
    window.addEventListener('resize',expandAll)
    function expandAll(e){
      var tag = document.querySelectorAll('textarea')
      for (var i=0; i<tag.length; i++){
        autoExpand(e,tag[i])
      }
    }
  })()

  // TYPE DE TRANSACTION

  $("#buy, #sale").on('click',function(e){
    if(e.target.id == "sale"){
      $(this).toggleClass('selected')
      $("#buy").removeClass('selected')
    }else if(e.target.id == "buy"){
      $(this).toggleClass('selected')
      $("#sale").removeClass('selected')
    }
  })

  $('#budget').keydown(function(e){
    var key = e.charCode || e.keyCode || 0;
    // allow backspace, tab, delete, enter, arrows, numbers and keypad numbers ONLY
    // home, end, period, and numpad decimal
    return (
       key == 8 ||
       key == 9 ||
       key == 13 ||
       key == 46 ||
       key == 110 ||
       key == 190 ||
       (key >= 35 && key <= 40) ||
       (key >= 48 && key <= 57) ||
       (key >= 96 && key <= 105)
    );
  }).keyup(function() {
      this.value = this.value.replace(/ /g,'');
      var number = this.value;
      this.value = number.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  });

  $('#phone').on("blur",function(){
    var value = $(this).val();
    if(value != ""){
      var phoneReplaces = value.replace(/ |,|-|_/g, '');
      var regexPhone = /^\d{10}$/;

      if(!regexPhone.test(phoneReplaces)){
        document.getElementById('warn-phone').innerHTML = "Le numéro indiqué n'est pas valide."
      }else{
        document.getElementById('warn-phone').innerHTML = ""
        var phone = phoneReplaces.replace(/(\w{2})/g, '$1 ').replace(/(^\s+|\s+$)/,'');
        $(this).val(phone)
      }

    }
  })

  // TYPE DE BIEN

  $("#flat, #house, #ground").on('click',function(e){
    if(e.target.id == "flat"){
      $(this).toggleClass('selected')
      $("#house, #ground").removeClass('selected')
    }else if(e.target.id == "house"){
      $(this).toggleClass('selected')
      $("#flat, #ground").removeClass('selected')
    }else if(e.target.id == "ground"){
      $(this).toggleClass('selected')
      $("#flat, #house").removeClass('selected')
    }
  })


  $(".more").on('click',function(){
    $('.expand').toggleClass('show');
  })

  $("#send").on('click',function(){

    var name =  document.getElementById('name').value;
    var phone =  document.getElementById('phone').value;
    var email = document.getElementById('email').value;
    var message =  document.getElementById('message').value;

    var regexEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

    if(name == ''){
      document.getElementById('warn-name').innerHTML = "Veuillez indiquer votre nom et prénom."
    }else{
      document.getElementById('warn-name').innerHTML = ""
    }

    var phoneReplaces = phone.replace(/ |,|-|_/g, '');
    var regexPhone = /^\d{10}$/;

    if(!regexPhone.test(phoneReplaces)){
      document.getElementById('warn-phone').innerHTML = "Le numéro indiqué n'est pas valide."
    }else{
      document.getElementById('warn-phone').innerHTML = ""
    }

    if(!regexEmail.test(email)){
      document.getElementById('warn-email').innerHTML = "L'email indiqué n'est pas valide."
    }else{
      document.getElementById('warn-email').innerHTML = ""
    }


    if(name == '' || !regexPhone.test(phoneReplaces) || !regexEmail.test(email) ){
      return false;
    }else{
      var obj = {}
      obj.name = name;
      obj.email = email;
      obj.phone = phone;
      obj.message = message;

      if($("#buy").hasClass('selected')){
        obj.transaction = "Acheter";
      }else if($("#sale").hasClass('selected')){
        obj.transaction = "Vendre";
      }

      if($("#flat").hasClass('selected')){
        obj.bien = "Appartement";
      }else if($("#house").hasClass('selected')){
        obj.bien = "Maison";
      }else if($("#ground").hasClass('selected')){
        obj.bien = "Terrain";
      }

      if($('#budget').val() !== ''){
        obj.budget = $('#budget').val()
      }

      if($('#room').val() !== ''){
        obj.room = $('#room').val()
      }

      if($('#superficie').val() !== ''){
        obj.superficie = $('#superficie').val()
      }

      if($('#city').val() !== ''){
        obj.city = $('#city').val()
      }
      $.ajax({
        type: "POST",
        url: 'https://api.agenceduchateau.bakasable.fr/mail',
        data: obj,
        success: function(res){
          if(res.message == 'Message envoyé'){
            $('#info').text('Message envoyé')
            $('#info').css({display : "block"})
            setTimeout(function(){
              $('#info').text('')
              $('#info').css({display : "none"})
            },4000)
          }
        },
        error: function() { alert('Erreur envoie email'); }
      });

    }

  })

});



// WEBPACK FOOTER //
// ./src/js/contact.js